import React from 'react';

import { Box, Stack } from '@mui/material';

import { FullscreenLoader } from 'src/components/common';
import { useCurrentUserEmployee } from 'src/hooks/employee';
import { useCurrentUserStatesList } from 'src/hooks/states';

import { ActivityLogStateAccount } from './ActivityLogStateAccount';
import { DeleteYourData } from './DeleteYourData';
import { VerificationPreferenceForm } from './VerificationPreferenceForm';

export const PrivacySettings: React.FC = () => {
  const { consumer, loading: loadingConsumer } = useCurrentUserEmployee();

  const { statesList, loading: loadingStates } = useCurrentUserStatesList();

  if (loadingConsumer || loadingStates) {
    return <FullscreenLoader />;
  }

  return (
    <Box>
      <Stack spacing={4}>
        <ActivityLogStateAccount consumer={consumer} consumerFreeze={consumer?.freeze} />
        <DeleteYourData consumer={consumer} states={statesList} />
        <VerificationPreferenceForm consumer={consumer} />
      </Stack>
    </Box>
  );
};
